/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllMitarbeiterAttribute$Json } from '../fn/mitarbeiter-attribut/get-all-mitarbeiter-attribute-json';
import { GetAllMitarbeiterAttribute$Json$Params } from '../fn/mitarbeiter-attribut/get-all-mitarbeiter-attribute-json';
import { getAllMitarbeiterAttribute$Plain } from '../fn/mitarbeiter-attribut/get-all-mitarbeiter-attribute-plain';
import { GetAllMitarbeiterAttribute$Plain$Params } from '../fn/mitarbeiter-attribut/get-all-mitarbeiter-attribute-plain';
import { MitarbeiterAttributDto } from '../models/mitarbeiter-attribut-dto';

@Injectable({ providedIn: 'root' })
export class MitarbeiterAttributApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllMitarbeiterAttribute()` */
  static readonly GetAllMitarbeiterAttributePath = '/v1/mitarbeiter-attribute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMitarbeiterAttribute$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMitarbeiterAttribute$Plain$Response(params?: GetAllMitarbeiterAttribute$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MitarbeiterAttributDto>>> {
    return getAllMitarbeiterAttribute$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMitarbeiterAttribute$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMitarbeiterAttribute$Plain(params?: GetAllMitarbeiterAttribute$Plain$Params, context?: HttpContext): Observable<Array<MitarbeiterAttributDto>> {
    return this.getAllMitarbeiterAttribute$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MitarbeiterAttributDto>>): Array<MitarbeiterAttributDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMitarbeiterAttribute$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMitarbeiterAttribute$Json$Response(params?: GetAllMitarbeiterAttribute$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MitarbeiterAttributDto>>> {
    return getAllMitarbeiterAttribute$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMitarbeiterAttribute$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMitarbeiterAttribute$Json(params?: GetAllMitarbeiterAttribute$Json$Params, context?: HttpContext): Observable<Array<MitarbeiterAttributDto>> {
    return this.getAllMitarbeiterAttribute$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MitarbeiterAttributDto>>): Array<MitarbeiterAttributDto> => r.body)
    );
  }

}
